import { render, staticRenderFns } from "./LabelAdl.vue?vue&type=template&id=a375c514&lang=pug"
import script from "./LabelAdl.vue?vue&type=script&lang=ts"
export * from "./LabelAdl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports